import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

/**
 * Role gate for a route the sidebar already hides.
 *
 * Hiding the menu entry is navigation, not authorization: the URL still
 * resolves, and the server's 403 would leave the page rendering an empty
 * error state that reads like a broken screen. Anyone landing here without
 * the role is sent back to the default overview; the server remains the real
 * lock.
 */
export function RequireRole({ roles }: { roles: string[] }) {
  const { user } = useAuth();

  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/anatel/overview" replace />;
  }

  return <Outlet />;
}
